/** Tag and person field handlers for the task form. */
import { useCallback } from 'react';

export const useTaskFormTagHandlers = ({ setTask }) => {
  const handleProjectsChange = useCallback(
    (_, v) => setTask((p) => ({ ...p, projects: Array.isArray(v) ? v : [v] })),
    [setTask],
  );

  const handleContextsChange = useCallback(
    (_, v) => setTask((p) => ({ ...p, contexts: Array.isArray(v) ? v : [v] })),
    [setTask],
  );

  const handlePersonChange = useCallback(
    (_, v) => setTask((p) => ({ ...p, person: v || null })),
    [setTask],
  );

  return {
    handleProjectsChange,
    handleContextsChange,
    handlePersonChange,
  };
};
